<template>
  <div class="position-relative" style="min-height: 50vh">
    <title-ribbon
      v-if="!auto_change && deActive"
      title="ارسال آگهی تکی"
    ></title-ribbon>
    <!--        <ads-selector></ads-selector>-->
    <div v-if="deActive" class="mt-10 pt-15 px-0 float-left">
      <extra-buttons />
    </div>

    <v-col v-if="!auto_change" class="mx-auto pa-0" cols="12" lg="6" md="8">
      <v-card-title>انتخاب شماره تماس:</v-card-title>
      <number-selector
        ref="number"
        :force="true"
        :has_national="isNational"
        :multiple-numbers="false"
      />
    </v-col>

    <template
      v-if="
        !!schema.advertise &&
        !!schema.advertise.contact &&
        !!schema.advertise.contact.phone
      "
    >
      <v-col class="mx-auto pa-0 col-md-8 col-lg-6 col-12">
        <categoryselector
          ref="category"
          :edit="false"
          :fields="fields"
          :multiAdsCat="false"
          :page-name="namePage"
          :phone="schema.advertise.contact.phone"
          @category-schema="getSchema"
          @category-fields="getFields"
          @category-current="getCurrent"
        />
      </v-col>

      <v-col v-if="!auto_change" class="mx-auto pa-0" cols="12" lg="6" md="8">
        <city-selectorsingle ref="city" :force="true" />
        <!-- <city-selector ref="city" :force="true" /> -->

        <pic-selector :count="10" :required="true" ref="picSelector" />

        <call-method v-if="showCall" class="col-md-8 mx-auto" />
      </v-col>

      <input-maker
        ref="inputs"
        :fields="fields"
        :param="schema.advertise"
        :ui_schema="ui_schema"
      />

      <setting-ads v-if="!auto_change" />

      <v-col v-if="!auto_change" class="mx-auto pa-0" cols="12" lg="6" md="8">
        <v-card-actions class="justify-end">
          <v-btn
            :loading="loading"
            class="btn submit-btn ma-0"
            @click="authenticate"
          >
            <v-icon left>mdi-content-save-check-outline</v-icon>
            ثبت آگهی
          </v-btn>
        </v-card-actions>
      </v-col>
    </template>
  </div>
</template>

<script>
import Categoryselector from "@/view/pages/ads/categorySelector";
// import CitySelector from "@/view/pages/ads/citySelector";
import citySelectorsingle from "../citySelectorsingle.vue";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import NumberSelector from "@/view/pages/ads/numberSelector";
import AdsSelector from "@/view/pages/ads/adsSelector";
import InputMaker from "@/view/pages/ads/inputMaker";
import SettingAds from "@/view/pages/ads/settingAds";
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import { Bus } from "@/main";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import PublicButton from "@/view/pages/uiBeautifier/buttonTempl";
import ExtraButtons from "@/view/pages/uiBeautifier/extraButtons";
import CallMethod from "../callMethod";
import { mapActions } from "vuex";
import CitySelectorsingle from "../citySelectorsingle.vue";

export default {
  name: "simpleAds",

  components: {
    CallMethod,
    ExtraButtons,
    PublicButton,
    ButtonTempl,
    TitleRibbon,
    PicSelector,
    SettingAds,
    InputMaker,
    AdsSelector,
    NumberSelector,
    Automatics,
    CitySelectorsingle,
    Categoryselector,
  },

  props: {
    ui_schema: {
      type: Array,
      default() {
        return [];
      },
    },
    auto_change: {
      default: false,
    },
    deActive: {
      default: false,
    },
  },

  data() {
    return {
      error: "",
      picker: "",
      showCall: false,
      submitMessage: "",
      namePage: this.pageName,
      current: "",
      isNational: false,
      fields: [],
      schema: {
        advertise: {
          Category: "",
          location: {
            city: "",
            neighborhood: "",
          },
          Images: [],
          contact: {
            chat_enabled: true,
            call_method: undefined,
            hide_phone: false,
            phone: null,
          },
        },
        available_at: "",
        expire_at: "",
        auto_pay: "",
      },
      loading: false,
    };
  },

  mounted() {
    Bus.$on("cityInfo", (value) => {
      // this.schema.advertise.location.city = value.city;
      this.schema.advertise.Location_CityId = {
        integer: {
          value: value.city,
        },
      };

      if (value.neighborhood === "") {
        delete this.schema.advertise.Location_NeighborhoodId;
        // delete this.schema.advertise.location.neighborhood;
      } else {
        this.schema.advertise.Location_NeighborhoodId = {
          integer: {
            value: value.neighborhood,
          },
        };
        // this.schema.advertise.location.neighborhood = value.neighborhood;
      }
    });

    Bus.$on("category-current", (current) => {
      this.schema.advertise.Category = {
        str: {
          value: current,
        },
      };
      this.current = current;
    });

    Bus.$on("contact", (value) => {
      this.schema.advertise.contact.chat_enabled = value.chat_enabled;
      this.schema.advertise.contact.hide_phone = value.hide_phone;
      this.schema.auto_pay = value.autoPay;
    });

    Bus.$on("selected_numbers", (value) => {
      this.setAdvertiseContactPhone(value);
      this.schema.advertise.contact.phone = value;
    });

    Bus.$on("selectedImage", (value) => {
      // this.schema.advertise.images = value;
      if (!!value) {
        this.schema.advertise.Images = {
          repeated_string: {
            value: [...value],
          },
        };
      } else {
        this.error = "حداقل یک عکس انتخاب شود.";
      }
    });

    Bus.$on("reload", (fields) => {
      this.fields = fields;
    });

    Bus.$on("times", (value) => {
      this.schema.available_at = value.times.starttime;
      this.schema.expire_at = value.times.endtime;
    });

    Bus.$on("national", (value) => {
      this.isNational = value;
    });

    Bus.$on("callMethod", (value) => {
      this.schema.advertise.contact.call_method = value;
    });
  },

  watch: {
    current(val) {
      if (
        val === "shoes-belt-bag" ||
        val === "clothing-and-shoes" ||
        val === "clothing"
      ) {
        {
          this.schema.advertise.contact.call_method = "secure_call";
          this.showCall = true;
        }
      } else {
        this.schema.advertise.contact.call_method = undefined;
        this.showCall = false;
      }
    },
  },

  methods: {
    ...mapActions("divar", ["setAdvertiseContactPhone"]),
    getSchema: function (value) {
      this.ui_schema = value;
    },
    authenticate() {
      this.sendAds();

      // this.$modal.showLoading();
      //
      // this.loading = true
      // $.ajax({
      //   url: `${url}/divar/check/title`,
      //   type: "POST",
      //   fn: this.authenticate,
      //   headers: {
      //     ACCEPT: "application/json",
      //     Authorization: Token,
      //     "Content-type": 'application/json'
      //   },
      //   data: JSON.stringify({
      //     "title": this.schema.advertise['title'],
      //     "city": String(this.schema.advertise.location.city),
      //     "category": this.schema.advertise.Category
      //   }),
      //   msg: false,
      //   error: (data) => {
      //     if (data.status === 422) {
      //       this.$modal.error('خطا', 'لطفا اطلاعات فرم را کامل نمایید.')
      //     } else {
      //       this.$modal.error('خطا', 'عنوان مورد نظر قابل قبول نمی باشد.');
      //     }
      //     this.loading = false
      //   },
      //   success: (data) => {
      //     this.sendAds();
      //     this.loading = false
      //   }
      // });
    },
    getFields: function (val) {
      this.fields = val;
    },
    getCurrent: function (value) {
      this.current = value;
    },
    sendAds() {
      let data = this.schema;
      if (
        !this.$refs.inputs.validate() ||
        !this.$refs.number.validate() ||
        !this.$refs.city.validate()
      )
        return;
      if (!this.$refs.picSelector.validate()) {
        this.$toast.error("حداقل یک عکس انتخاب شود.");

        return;
      }
      if (data.available_at === "") {
        delete data.available_at;
      }

      if (data.expire_at === "") {
        delete data.expire_at;
      }

      if (
        data.advertise.location.neighborhood === "" ||
        data.advertise.location.neighborhood === null ||
        data.advertise.location.neighborhood === undefined
      )
        delete data.advertise.location.neighborhood;

      this.$modal.showLoading();

      data = {
        ...data,
        advertise: {
          data: { ...data.advertise },
        },
      };

      $.ajax({
        url: `${url}/divar/advertise/send`,
        method: "POST",
        fn: this.sendAds,
        headers: {
          AUTHORIZATION: Token,
          "Content-Type": "application/json",
          ACCEPT: "application/json",
        },
        data: JSON.stringify(data),
        msg: true,
        redirect: { path: "/adsList/myAdsList" },
      });
    },
  },
};
</script>
